<template>
  <div id="navigation-title" v-if="communityData">
    <b-row></b-row>
    <b-row v-if="!hideHeader">
      <b-col cols="12" v-if="communityData.baseData" class="text-center">
        <b-img :src="communityData.baseData.logoHochladen[0].url" fluid></b-img>
      </b-col>
      <b-col cols="12">
        <br>
        <b-row>
          <b-col cols="10">
            <h3 v-if="!$route.path.includes('thankyou')">{{ formName }}</h3>
          </b-col>
          <b-col v-if="languageOptions.length > 1">
            <b-form-select v-model="selectedLanguage" :options="languageOptions" @change="onLanguageChange"></b-form-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    communityData: {
      type: Object,
      required: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    formName: {
      type: String,
      required: true
    },
    language: {
      type: String,
      default: 'de'
    },
    languageOptions: {
      type: Array,
      default: () => [{ value: 'de', text: 'Deutsch', selected: true }]
    }
  },
  data() {
    return {
      selectedLanguage: this.language
    };
  },
  methods: {
    onLanguageChange() {
      this.$emit('language-change', this.selectedLanguage);
    }
  }
}
</script> 